import React from "react";

import { ReactComponent as IconDelete } from "../../build/mui-mult-select-assets/close-circle.svg";

const TooltipText = (items, onRemove = null, disabled = false) => {
  return (
    <div className="subservices-tags-container">
      {items.map((item, index) => (
        <div
          className="subservice-tag"
          style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}
        >
          <span key={item.id || index}>{item.label}</span>
          {onRemove && !disabled && (
            <button
              className="subservice-tag__remove-btn"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "none",
                backgroundColor: "transparent",
                margin: "0rem",
                padding: "0rem",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(item, index);
              }}
            >
              <IconDelete />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default TooltipText;
